import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "contributing"
    }}>{`Contributing`}</h1>
    <p>{`When contributing to this repository, please first discuss the change you wish to make via issue,
email, or any other method with the owners of this repository before making a change. `}</p>
    <p>{`Please note we have a code of conduct, please follow it in all your interactions with the project.`}</p>
    <h2 {...{
      "id": "pull-request-process"
    }}>{`Pull Request Process`}</h2>
    <ol>
      <li parentName="ol">{`Ensure any install or build dependencies are removed before the end of the layer when doing a
build.`}</li>
      <li parentName="ol">{`Update the README.md with details of changes to the interface, this includes new environment
variables, exposed ports, useful file locations and container parameters.`}</li>
      <li parentName="ol">{`Increase the version numbers in any examples files and the README.md to the new version that this
Pull Request would represent. The versioning scheme we use is `}<a parentName="li" {...{
          "href": "http://semver.org/"
        }}>{`SemVer`}</a>{`.`}</li>
      <li parentName="ol">{`You may merge the Pull Request in once you have the sign-off of two other developers, or if you
do not have permission to do that, you may request the second reviewer to merge it for you.`}</li>
    </ol>
    <h2 {...{
      "id": "code-of-conduct"
    }}>{`Code of Conduct`}</h2>
    <h3 {...{
      "id": "our-pledge"
    }}>{`Our Pledge`}</h3>
    <p>{`In the interest of fostering an open and welcoming environment, we as
contributors and maintainers pledge to making participation in our project and
our community a harassment-free experience for everyone, regardless of age, body
size, disability, ethnicity, gender identity and expression, level of experience,
nationality, personal appearance, race, religion, or sexual identity and
orientation.`}</p>
    <h3 {...{
      "id": "our-standards"
    }}>{`Our Standards`}</h3>
    <p>{`Examples of behavior that contributes to creating a positive environment
include:`}</p>
    <ul>
      <li parentName="ul">{`Using welcoming and inclusive language`}</li>
      <li parentName="ul">{`Being respectful of differing viewpoints and experiences`}</li>
      <li parentName="ul">{`Gracefully accepting constructive criticism`}</li>
      <li parentName="ul">{`Focusing on what is best for the community`}</li>
      <li parentName="ul">{`Showing empathy towards other community members`}</li>
    </ul>
    <p>{`Examples of unacceptable behavior by participants include:`}</p>
    <ul>
      <li parentName="ul">{`The use of sexualized language or imagery and unwelcome sexual attention or
advances`}</li>
      <li parentName="ul">{`Trolling, insulting/derogatory comments, and personal or political attacks`}</li>
      <li parentName="ul">{`Public or private harassment`}</li>
      <li parentName="ul">{`Publishing others' private information, such as a physical or electronic
address, without explicit permission`}</li>
      <li parentName="ul">{`Other conduct which could reasonably be considered inappropriate in a
professional setting`}</li>
    </ul>
    <h3 {...{
      "id": "our-responsibilities"
    }}>{`Our Responsibilities`}</h3>
    <p>{`Project maintainers are responsible for clarifying the standards of acceptable
behavior and are expected to take appropriate and fair corrective action in
response to any instances of unacceptable behavior.`}</p>
    <p>{`Project maintainers have the right and responsibility to remove, edit, or
reject comments, commits, code, wiki edits, issues, and other contributions
that are not aligned to this Code of Conduct, or to ban temporarily or
permanently any contributor for other behaviors that they deem inappropriate,
threatening, offensive, or harmful.`}</p>
    <h3 {...{
      "id": "scope"
    }}>{`Scope`}</h3>
    <p>{`This Code of Conduct applies both within project spaces and in public spaces
when an individual is representing the project or its community. Examples of
representing a project or community include using an official project e-mail
address, posting via an official social media account, or acting as an appointed
representative at an online or offline event. Representation of a project may be
further defined and clarified by project maintainers.`}</p>
    <h3 {...{
      "id": "enforcement"
    }}>{`Enforcement`}</h3>
    <p>{`Instances of abusive, harassing, or otherwise unacceptable behavior may be
reported by contacting the project team at `}<inlineCode parentName="p">{`tapas.adhikary@gmail.com`}</inlineCode>{`. All
complaints will be reviewed and investigated and will result in a response that
is deemed necessary and appropriate to the circumstances. The project team is
obligated to maintain confidentiality with regard to the reporter of an incident.
Further details of specific enforcement policies may be posted separately.`}</p>
    <p>{`Project maintainers who do not follow or enforce the Code of Conduct in good
faith may face temporary or permanent repercussions as determined by other
members of the project's leadership.`}</p>
    <h3 {...{
      "id": "attribution"
    }}>{`Attribution`}</h3>
    <p>{`This Code of Conduct is adapted from the `}<a parentName="p" {...{
        "href": "http://contributor-covenant.org"
      }}>{`Contributor Covenant`}</a>{`, version 1.4,
available at `}<a parentName="p" {...{
        "href": "http://contributor-covenant.org/version/1/4/"
      }}>{`http://contributor-covenant.org/version/1/4`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      